const Text = {
  baseStyle: {
    marginBottom: '0px',
  },
  variants: {
    formLabel: {
      fontSize: '14px',
      fontWeight: '400',
      lineHeight: '20px',
      color: '#666666',
    },
    hint: {
      fontSize: '14px',
      fontWeight: '400',
      lineHeight: '20px',
      color: '#999999',
    },
    hintIcon: {
      fontWeight: '400',
      color: '#999999',
    },
    progressBarHint: {
      fontSize: '12px',
      color: '#999999',
    },
    sectionTitle: {
      fontSize: '15px',
      fontWeight: '600',
      lineHeight: '20px',
      color: '#5B5B5B',
    },
    sectionSubTitle: {
      fontSize: '14px',
      fontWeight: '700',
      lineHeight: '20px',
      color: '#666666',
    },
    tierTag: {
      fontSize: '15px',
      fontWeight: '600',
      lineHeight: '21px',
      color: '#ffffff',
      padding: '2px 10px',
      border: '1px solid #ffffff',
      borderRadius: '300px',
      backgroundColor: '#f0ad4e',
      display: 'inline-flex',
      alignItems: 'center',
      boxSizing: 'border-box',
    },
    description: {
      fontSize: '14px',
      lineHeight: '20px',
      color: '#4A4A4A',
    },
    verified: {
      color: '#30652F',
      fontSize: '12px',
      lineHeight: '16px',
    },
    unverified: {
      color: '#A94442',
      fontSize: '12px',
      lineHeight: '16px',
    },
    errorMessage: {
      color: '#A94442',
      fontSize: '12px',
      lineHeight: '16px',
    },
    successMessage: {
      color: '#3c763d',
      fontSize: '12px',
      lineHeight: '16px',
    },
    modalSectionTitle: {
      fontSize: '16px',
      fontWeight: '700',
      color: '#333333',
    },
    modalDescription: {
      fontSize: '16px',
      fontWeight: 'normal',
      color: '#333333',
    },
    checkMobileNumber: {
      fontSize: '20px',
      fontWeight: 'normal',
      lineHeight: '46px',
      color: '#333333',
    },
    avatarText: {
      fontSize: '14px',
      fontWeight: 'normal',
      lineHeight: '20px',
      color: '#333333',
    },
    avatarDisableText: {
      fontSize: '14px',
      fontWeight: 'normal',
      lineHeight: '20px',
      color: '#999999',
    },
    expiredTag: {
      fontSize: '10px',
      fontWeight: 'normal',
      lineHeight: '20px',
      color: '#D59201',
      padding: '0px 5px',
      border: '1px solid #FAF1DF',
      borderRadius: '10px',
    },
    subscribeText: {
      fontSize: '14px',
      lineHeight: '20px',
    },
  },
};

export default Text;
